import React from "react";
import "./LabAdmin.css";
export default function LabAdmin() {
  return (
    <div className="LabAdmin">
      <h1>Admin Panel</h1>
    </div>
  );
}
